module.exports = __webpack_public_path__ + "static/media/acc-deleted.32a6db18.svg";